import React from 'react';
import styled from 'styled-components';
import { 
  FaUserTie, 
  FaLaptopCode, 
  FaBookOpen, 
  FaUsers, 
  FaCertificate, 
  FaChartLine 
} from 'react-icons/fa';
import SectionHeader from '../common/SectionHeader';

const ChooseUsSection = styled.section`
  background-color: ${props => props.theme.colors.lightColor};
  padding: 80px 0;
`;

const FeaturesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 30px;
`;

const FeatureItem = styled.div`
  background-color: ${props => props.theme.colors.white};
  padding: 30px;
  border-radius: ${props => props.theme.borders.radius.regular};
  box-shadow: ${props => props.theme.shadows.regular};
  transition: ${props => props.theme.transitions.main};
  
  &:hover {
    transform: translateY(-10px);
  }
`;

const FeatureIcon = styled.div`
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: rgba(52, 152, 219, 0.1);
  color: ${props => props.theme.colors.primaryColor};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  margin-bottom: 20px;
`;

const FeatureTitle = styled.h3`
  font-size: ${props => props.theme.fontSizes.large};
  margin-bottom: 15px;
  color: ${props => props.theme.colors.secondaryColor};
`;

const FeatureDescription = styled.p`
  color: ${props => props.theme.colors.grey[600]};
  line-height: 1.7;
`;

const WhyChooseUs = () => {
  const features = [
    {
      icon: <FaUserTie />,
      title: 'Expert Faculty',
      description: 'Learn from industry experts with extensive practical experience in structural engineering and design.'
    },
    {
      icon: <FaLaptopCode />,
      title: 'Practical Training',
      description: 'Hands-on training with real-world projects and case studies to develop practical skills.'
    },
    {
      icon: <FaBookOpen />,
      title: 'Comprehensive Curriculum',
      description: 'Well-structured courses covering all aspects of structural engineering and design.'
    },
    {
      icon: <FaUsers />,
      title: 'Small Batch Sizes',
      description: 'Limited students per batch ensuring personalized attention and better learning outcomes.'
    },
    {
      icon: <FaCertificate />,
      title: 'Industry Recognition',
      description: 'Our certifications are valued by employers for their quality and relevance.'
    },
    {
      icon: <FaChartLine />,
      title: 'Proven Track Record',
      description: 'High success rate of students in competitive exams and job placements.'
    }
  ];

  return (
    <ChooseUsSection>
      <div className="container">
        <SectionHeader 
          title="Why Choose KALS Academy" 
          subtitle="What sets us apart from other institutions" 
        />
        
        <FeaturesGrid>
          {features.map((feature, index) => (
            <FeatureItem key={index}>
              <FeatureIcon>{feature.icon}</FeatureIcon>
              <FeatureTitle>{feature.title}</FeatureTitle>
              <FeatureDescription>{feature.description}</FeatureDescription>
            </FeatureItem>
          ))}
        </FeaturesGrid>
      </div>
    </ChooseUsSection>
  );
};

export default WhyChooseUs;
